export default function Home() {
    return (
      <section>
        <h2 className="text-3xl font-bold mb-4">Welcome to My Portfolio</h2>
        <p>
          I'm Dan, a software developer with a passion for building cool tech projects. Scroll
          through my work or get in touch!
        </p>
      </section>
    );
  }
  